




















































































import { Component, Vue } from 'vue-property-decorator';
import Loading from 'vue-loading-overlay';
import { eventBus } from '@/main';
import { DATA } from '@/config/data';
import Paging from '@/shared/components/Paging.vue';
import { APP_CONFIG } from '@/config/app-config';
import { RechargeHistory } from '@/models/recharge-history';
import creditServices from '@/services/credit-services';

@Component({
    components: {
        Paging,
        Loading
    }
})
export default class RechargeHistories extends Vue {
    private pageSettings = {
      rowPerPage: 10,
      pageSize: 6,
      pageIndex: 1,
      total: 0,
    };

    private listRechargeHistories: RechargeHistory[] = [];
    private isLoading = false;

    private async created() {
        eventBus.$on(APP_CONFIG.eventBusAction.reloadWithdrawalHistories, () => {
            this.pageSettings.pageIndex = 1;
            this.loadHistories();
        });
        this.loadHistories();
    }

    private async cancelRequest(id: number) {
        if (confirm('Bạn có chắc chắn muốn hủy yêu cầu nạp này?')) {
            const result = await creditServices.cancelRechargeRequest(id);
            if (result && result.status === 200 && result.data.status === 200) {
                Vue.notify({
                    group: 'foo',
                    type: 'success',
                    title: 'Thông báo!',
                    text: 'Hủy yêu cầu nạp tiền thành công!',
                });
                this.loadHistories();
            } else {
                Vue.notify({
                    group: 'foo',
                    type: 'error',
                    title: 'Thông báo!',
                    text: 'Hủy yêu cầu nạp tiền thất bại!',
                });
            }
        }
    }

    private async loadHistories() {
        this.isLoading = true;
        const result = await creditServices.rechargeHistories(this.pageSettings.pageIndex, this.pageSettings.rowPerPage, '');
        if (result && result.status === 200) {
            const rawList = Array.isArray(result.data.data) ? result.data.data : (result.data.data && result.data.data.list ? result.data.data.list : []);
            this.pageSettings.total = result.data.total !== undefined ? result.data.total : ((result.data.data && result.data.data.total) || 0);
            this.listRechargeHistories = rawList.map((item: any) => {
                const history: RechargeHistory = {
                    amount: item.Amount,
                    createdBy: item.CreatedBy || item.CreateBy,
                    createDate: item.CreatedDate || item.CreateDate,
                    id: item.ID,
                    method: item.Method || item.BankId,
                    rechargeId: item.RechargeID || item.ID,
                    status: item.Status,
                    tradeContent: item.TradeContent,
                    userRecharge: item.UserRecharge || item.Username,
                    userName: item.Username || item.UserName,
                    statusDetail: (DATA.statusRecharge || []).find((x: any) => x.value === item.Status) || { name: 'Chờ duyệt', color: '#f59e0b', textColor: '#fff' }
                };
                return history;
            });
        }
        this.isLoading = false;
    }

    private onChangePage(page: number) {
        this.pageSettings.pageIndex = page;
        this.loadHistories();
    }
}
